import { Box, HStack, View } from '@rbilabs/universal-components';

import Link from 'components/link';
import { ZIndex, getDesignToken } from 'styles/constants';

const headerIconPressedBg = getDesignToken('background-icon-header-contrast');

const headerIconContainerStyles = {
  zIndex: ZIndex.OVERLAY,
  _pressed: {
    backgroundColor: headerIconPressedBg,
  },
  _focus: {
    backgroundColor: headerIconPressedBg,
  },
  _hover: {
    backgroundColor: headerIconPressedBg,
    color: 'inherit',
  },
};

// The absolute position pops it out of the flex flow
// and this allows our centered logo to be truly centered and not offset by the menu item
export const MenuButtonContainer = Box.withConfig({
  position: 'absolute',
  zIndex: 1,
  flexShrink: 1,
  left: 0,
});

export const Header = HStack.withConfig({
  alignItems: 'center',
  color: getDesignToken('text-reversed'),
  height: getDesignToken('layout-nav-height-mobile'),
  justifyContent: 'space-between',
  textAlign: 'center',
  width: 'full',
});

export const LinkNoDecoration = Link.withConfig({
  ...headerIconContainerStyles,
});

export const StyledCenterSpacer = Box.withConfig({
  flexGrow: 1,
  alignItems: 'flex-end',
  textAlign: 'center',
});

export const StyledRightSpacer = Box.withConfig({
  flex: 1,
  alignItems: 'flex-end',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  _web: {
    gap: '$4',
  },
});

export const StyledLogo = View.withConfig({
  marginX: 'auto',
  justifyContent: 'center',
  accessibilityRole: 'link',
  accessibilityLabel: 'Burger King Logo. Navigate to Home',
});
